import { InferenceSetup } from "@/inference/setup";
import { SDKConfiguration } from "@/inference/setup/config";
import { BrandSettings } from "@/types/brand-settings";

export class BrandSettingsProvider {
  private static instance: BrandSettingsProvider;
  private static settings: BrandSettings | null = null;

  private constructor() {}

  static getInstance(): BrandSettingsProvider {
    if (!this.instance) {
      this.instance = new BrandSettingsProvider();
    }
    return this.instance;
  }

  static getSettings(): Readonly<BrandSettings> | null {
    return this.settings;
  }

  static async init(): Promise<void> {
    const orgId = window.helium.brandData?.orgId;
    const storeId = window.helium.brandData?.storeId;

    if (!orgId || !storeId) {
      InferenceSetup.killswitch();
    }

    try {
      const response = await fetch(
        SDKConfiguration.BRAND_SETTINGS(orgId, storeId),
      );

      if (!response.ok) {
        InferenceSetup.killswitch();
      }

      const settings = await response.json();
      this.settings = Object.freeze(settings);
    } catch {
      InferenceSetup.killswitch();
    }
  }

  static isFeatureEnabled(featureName: string): boolean {
    return this.settings?.featureFlags[featureName]?.enabled ?? false;
  }
}
